"use client";

import { FEATURE_FLAGS } from ".constants/featureFlags";
import { Button, Icon } from "@cloai/uikit";
import { ReactNode } from "react";

import { useABtestContext, useThemeContext } from "@/providers";

type ThemeTogglerVariant = "default" | "burger";

type ThemeTogglerProps = {
  variant?: ThemeTogglerVariant;
};

export const ThemeToggler = ({ variant = "default" }: ThemeTogglerProps) => {
  const { theme, toggleTheme } = useThemeContext();
  const { AAB_RedesignV1, AAB_RedesignV2 } = useABtestContext();
  const AAB_Redesign = AAB_RedesignV1 || AAB_RedesignV2;

  if (
    !FEATURE_FLAGS.IS_REDESIGN_ENABLED ||
    !FEATURE_FLAGS.IS_LIGHT_THEME_ENABLED ||
    !AAB_Redesign
  ) {
    return null;
  }

  const variantComponent: Record<ThemeTogglerVariant, ReactNode> = {
    default: (
      <Button
        isIconOnly
        size="sm"
        radius="full"
        onClick={toggleTheme}
        className="!hide md:!flex"
      >
        <Icon icon={theme === "dark" ? "light_mode" : "dark_mode"} />
      </Button>
    ),
    burger: (
      <Button
        startContent={
          <Icon icon={theme === "dark" ? "light_mode" : "dark_mode"} />
        }
        variant="ghost"
        wide
        centerText
        onClick={toggleTheme}
      >
        {theme === "dark" ? "Light theme" : "Dark theme"}
      </Button>
    ),
  };

  return variantComponent[variant];
};
